import React from "react";
import { Link } from "react-router-dom";
import { Home, Search, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { createPageUrl } from "@/utils";

export default function PageNotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="h-20 w-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl font-bold text-primary">404</span>
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">Page not found</h1>
        <p className="text-muted-foreground mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to={createPageUrl("Home")}>
            <Button className="rounded-lg gap-2 w-full sm:w-auto">
              <Home className="h-4 w-4" /> Go Home
            </Button>
          </Link>
          <Link to={createPageUrl("Explore")}>
            <Button variant="outline" className="rounded-lg gap-2 w-full sm:w-auto">
              <Search className="h-4 w-4" /> Explore
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}